// This file is auto-generated by @hey-api/openapi-ts
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var separatorArrayExplode = function (style) {
    switch (style) {
        case "label":
            return ".";
        case "matrix":
            return ";";
        case "simple":
            return ",";
        default:
            return "&";
    }
};
export var separatorArrayNoExplode = function (style) {
    switch (style) {
        case "form":
            return ",";
        case "pipeDelimited":
            return "|";
        case "spaceDelimited":
            return "%20";
        default:
            return ",";
    }
};
export var separatorObjectExplode = function (style) {
    switch (style) {
        case "label":
            return ".";
        case "matrix":
            return ";";
        case "simple":
            return ",";
        default:
            return "&";
    }
};
export var serializeArrayParam = function (_a) {
    var allowReserved = _a.allowReserved, explode = _a.explode, name = _a.name, style = _a.style, value = _a.value;
    if (!explode) {
        var joinedValues_1 = (allowReserved ? value : value.map(function (v) { return encodeURIComponent(v); })).join(separatorArrayNoExplode(style));
        switch (style) {
            case "label":
                return ".".concat(joinedValues_1);
            case "matrix":
                return ";".concat(name, "=").concat(joinedValues_1);
            case "simple":
                return joinedValues_1;
            default:
                return "".concat(name, "=").concat(joinedValues_1);
        }
    }
    var separator = separatorArrayExplode(style);
    var joinedValues = value
        .map(function (v) {
        if (style === "label" || style === "simple") {
            return allowReserved ? v : encodeURIComponent(v);
        }
        return serializePrimitiveParam({
            allowReserved: allowReserved,
            name: name,
            value: v,
        });
    })
        .join(separator);
    return style === "label" || style === "matrix"
        ? separator + joinedValues
        : joinedValues;
};
export var serializePrimitiveParam = function (_a) {
    var allowReserved = _a.allowReserved, name = _a.name, value = _a.value;
    if (value === undefined || value === null) {
        return "";
    }
    if (typeof value === "object") {
        throw new Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
    }
    return "".concat(name, "=").concat(allowReserved ? value : encodeURIComponent(value));
};
export var serializeObjectParam = function (_a) {
    var allowReserved = _a.allowReserved, explode = _a.explode, name = _a.name, style = _a.style, value = _a.value, valueOnly = _a.valueOnly;
    if (value instanceof Date) {
        return valueOnly ? value.toISOString() : "".concat(name, "=").concat(value.toISOString());
    }
    if (style !== "deepObject" && !explode) {
        var values_1 = [];
        Object.entries(value).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], v = _b[1];
            values_1 = __spreadArray(__spreadArray([], __read(values_1), false), [
                key,
                allowReserved ? v : encodeURIComponent(v),
            ], false);
        });
        var joinedValues_2 = values_1.join(",");
        switch (style) {
            case "form":
                return "".concat(name, "=").concat(joinedValues_2);
            case "label":
                return ".".concat(joinedValues_2);
            case "matrix":
                return ";".concat(name, "=").concat(joinedValues_2);
            default:
                return joinedValues_2;
        }
    }
    var separator = separatorObjectExplode(style);
    var joinedValues = Object.entries(value)
        .map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], v = _b[1];
        return serializePrimitiveParam({
            allowReserved: allowReserved,
            name: style === "deepObject" ? "".concat(name, "[").concat(key, "]") : key,
            value: v,
        });
    })
        .join(separator);
    return style === "label" || style === "matrix"
        ? separator + joinedValues
        : joinedValues;
};
